export enum ConsultingGeneralType {
  RESIDENT_NUMBER = 'residentNumber',
  GENDER = 'gender',
  LAST_NAME = 'lastName',
  FIRST_NAME = 'firstName',
  ROOM = 'room',
  STATION = 'station',
  LIVING_AREA = 'livingArea',
  MOVE_IN_DATE = 'moveInDate',
  CARE_TYPE = 'careType',
  INITIAL_INTERVIEW_DATE = 'initialInterviewDate',
  INTEGRATION_INTERVIEW_DATE = 'integrationInterviewDate',
  RESULTS_OF_CONVERSATION = 'resultsOfConversationDocumented',
  LACK_OF_TRUST = 'notPossibleDueToLackOfTrust',
  OTHER_REASONS = 'notPossibleForOtherReasons',
  NOTES = 'notes',
}
